module.exports = __webpack_public_path__ + "6ddf5d53e411be79617aaa96751d9399.pdf";